<template>
  <div class="page-recherche-avancee page-recherche-avancee-produits">
    <main class="main">
      <breadcrumbs></breadcrumbs>

      <div class="page_title">
        <h1>Recherche avancée produits</h1>
      </div>

      <transition :duration="5" name="slide-fade" mode="out-in">
        <div v-if="toggleSearch" class="main-content" key="form">
          <form v-on:submit.prevent v-on:keydown.enter.prevent ref="form">
            <identity-form
              v-bind.sync="searchInput"
              :typesDataset="types"
              :naturesDataset="natures"
              :firmsDataset="firms"
              :formulationsDataset="formulations"
              :substancesDataset="substances"
              :familiesDataset="families"
              :statusDataset="status"
              :categoriesDataset="categories"
            ></identity-form>

            <uses-form
              :cultivationsList="cultivations"
              :targetsList="targets"
              v-bind.sync="searchInputWithOperator"
              :ephyCode.sync="searchInput.ephyCode"
              :applicationStartDay.sync="searchInput.applicationStartDay"
              :applicationStartMonth.sync="searchInput.applicationStartMonth"
              :applicationEndDay.sync="searchInput.applicationEndDay"
              :applicationEndMonth.sync="searchInput.applicationEndMonth"
              :cultivations.sync="searchInput.cultivations"
              :targets.sync="searchInput.targets"
            ></uses-form>

            <classification-form
              :classificationsList="classifications"
              :classifications.sync="searchInputWithClauseType.classifications"
              v-bind.sync="searchInput"
            ></classification-form>

            <div class="col-100 recherche-avancee-substances-footer">
              <button @click="clearSearch" class="grey-background">
                Effacer la recherche
              </button>
              <button
                @click="
                  search()
                  scrollToTop()
                "
                class="orange-background"
              >
                Rechercher
              </button>
            </div>
          </form>
        </div>
        <div v-else class="main-content" key="result">
          <advanced-search-modify-save-bar
            @modify-search="modifySearch()"
            :type="'product'"
          ></advanced-search-modify-save-bar>

          <advanced-search-facets
            :facets="facets"
            @updateFacets="updateFacets($event)"
            @showMoreFacet="
              queryParams[`${$event.key}Number`] = $event.number
              updateUrl()
            "
          ></advanced-search-facets>

          <products-listing
            :products="products"
            :routeNameToDetail="'productIdentityAdvancedSearch'"
            v-bind.sync="queryParams"
            @changePage="updateUrl()"
          ></products-listing>
        </div>
      </transition>
    </main>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs'
import ProductsListing from '@/components/ProductsListing'
import ClassificationForm from '@/components/ClassificationForm'
import AdvancedSearchFacets from '@/components/AdvancedSearchFacets'
import AdvancedSearchModifySaveBar from '@/components/AdvancedSearchModifySaveBar'
import IdentityForm from './components/IdentityForm'
import UsesForm from './components/UsesForm'
import SearchMixin from '@/mixins/SearchMixin.js'
import AdvancedSearchMixin from '@/mixins/AdvancedSearchMixin.js'
import Product from '@/api/products.js'
import Nature from '@/api/natures.js'
import Formulation from '@/api/formulations.js'
import Substance from '@/api/substances.js'

export default {
  name: 'ProductsAdvancedSearch',
  components: {
    Breadcrumbs,
    IdentityForm,
    UsesForm,
    ClassificationForm,
    ProductsListing,
    AdvancedSearchFacets,
    AdvancedSearchModifySaveBar
  },
  mixins: [SearchMixin, AdvancedSearchMixin],

  data () {
    return {
      toggleSearch: Boolean(!this.$route.params.results),
      queryParams: {
        page: 1
      },
      searchInput: {
        name: '',
        type: '',
        status: '',
        amm: '',
        category: '',
        nature: '',
        substances: [''],
        families: [''],
        formulations: [''],
        firm: '',
        formulationSigle: '',
        formulationDefinition: '',
        ab: '',
        gamme_amateur: '',
        gamme_pro: '',
        biocontrole: '',
        bee: '',
        cepp: false,
        family: '',
        end_marketing_date: '',
        removal_date: '',
        removal_dateOperator: '',
        first_authorisation_date: '', 
        first_authorisation_dateOperator: '', 
        end_marketing_dateOperator: '',
        end_use_dateOperator: '',
        end_use_date: '',
        ephyCode: '',
        applicationStartDay: '',
        applicationStartMonth: '',
        applicationEndDay: '',
        applicationEndMonth: '',
        cultivations: [''],
        targets: [''],
        cmr: false,
        
      },
      searchInputWithOperator: {
        bbchMin: '',
        bbchMinOperator: '',
        bbchMax: '',
        bbchMaxOperator: '',
        dar: '',
        darOperator: '',
        dre: '',
        dreOperator: '',
        iznt: '',
        izntOperator: '',
        zntArthro: '',
        zntArthroOperator: '',
        zntPlant: '',
        zntPlantOperator: ''
      },
      searchInputWithClauseType: {
        classifications: []
      },
      types: [],
      status: [],
      natures: [],
      substances: [],
      families: [],
      firms: [],
      formulations: [],
      cultivations: [],
      targets: [],
      classifications: {},
      categories: [],
      products: {},
      facets: {
        natures: {
          title: 'Fonctions',
          number: 3,
          availables: [],
          checked: [],
          count: null
        },
        firms: {
          title: 'Firmes détentrices',
          number: 3,
          availables: [],
          checked: [],
          count: null
        },
        categories: {
          title: 'Types commerciaux',
          number: 3,
          availables: [],
          checked: [],
          count: null
        },
        cultivations: {
          title: 'Cultures',
          number: 3,
          availables: [],
          checked: [],
          count: null
        },
        targets: {
          title: 'Cibles',
          number: 3,
          availables: [],
          checked: [],
          count: null
        }
      }
    }
  },

  created () {
    Promise.all([
      this.getTypes(),
      this.getStatus(),
      this.getNatures(),
      this.getSubstances(),
      this.getFamilies(),
      this.getFormulations(),
      this.getFirms(),
      this.getCultivations(),
      this.getTargets(),
      this.getClassifications(),
      this.getCategories()
    ]).then(() => {
      this.putQueryParamsInSearchInput()
      this.putQueryParamsInSearchInputWithOperator()
      this.putQueryParamsInSearchInputWithClauseType()
      this.putQueryParamsInFacets()
    })
    this.queryParams = { ...this.deepCopy(this.$route.query) }
    this.handleMultiValuatedQueryParam([
      'substances',
      'cultivations',
      'targets',
      'classifications',
      ...Object.keys(this.facets).map((key) => `${key}Facet`)
    ])
    if (!this.toggleSearch) this.getProducts()
  },

  beforeRouteUpdate (to, from, next) {
    this.toggleSearch = Boolean(!to.params.results)
    this.queryParams = { ...this.deepCopy(to.query) }
    this.handleMultiValuatedQueryParam([
      'substances',
      'cultivations',
      'targets',
      'classifications'
    ])
    this.putQueryParamsInSearchInput()
    this.putQueryParamsInSearchInputWithOperator()
    this.putQueryParamsInSearchInputWithClauseType()
    this.putQueryParamsInFacets()
    if (!this.toggleSearch) {
      Promise.resolve(this.getProducts()).finally(() => next())
    } else {
      next()
    }
  },

  methods: {
    getProducts () {
      this.queryParams.page = Number(this.queryParams.page) || 1
      return Product.list({
        ...this.queryParams,
        ...{ advancedSearch: true }
      }).then((response) => {
        this.products = response.products
        for (const prop in response.facets) {
          this.facets[prop] = { ...this.facets[prop], ...response.facets[prop] }
        }
      })
    },

    getTypes () {
      return Product.types().then((response) => {
        this.types = response
      })
    },

    getStatus () {
      return Product.status().then((response) => {
        this.status = response
      })
    },

    getNatures () {
      return Nature.list().then((response) => {
        this.natures = response
      })
    },

    getSubstances () {
      return Product.substances().then((response) => {
        this.substances = response
      })
    },

    getFamilies () {
      return Substance.families().then((response) => {
        this.families = response
      })
    },

    getFirms () {
      return Product.firms().then((response) => {
        this.firms = response
      })
    },

    getCultivations () {
      return Product.cultivations().then((response) => {
        this.cultivations = response
      })
    },

    getTargets () {
      return Product.targets().then((response) => {
        this.targets = response
      })
    },

    getClassifications () {
      return Product.classifications().then((response) => {
        this.classifications = response
        for (let i = 0; i < Object.keys(response).length; i++) {
          this.$set(this.searchInputWithClauseType.classifications, i, [])
        }
      })
    },

    getCategories () {
      return Product.categories().then((response) => {
        this.categories = response
      })
    },

    getFormulations () {
      return Formulation.list().then((response) => {
        this.formulations = response
      })
    },

    search () {
      if (this.$refs.form.checkValidity()) {
        this.putSearchInputInQueryParams()
        this.putSearchInputWithOperatorInQueryParams()
        this.putSearchInputWithClauseTypeInQueryParams()
        this.updateUrl({ results: 'results' })
      }
    },

    clearSearch () {
      this.queryParams.page = undefined
      for (const prop in this.searchInput) {
        this.searchInput[prop] = Array.isArray(this.searchInput[prop])
          ? ['']
          : ''
      }
      this.putSearchInputInQueryParams()
      for (const prop in this.searchInputWithOperator) {
        this.searchInputWithOperator[prop] = ''
      }
      this.putSearchInputWithOperatorInQueryParams()
      for (const prop in this.searchInputWithClauseType) {
        if (Array.isArray(this.searchInputWithClauseType[prop])) {
          for (const index in this.searchInputWithClauseType[prop]) {
            this.$set(this.searchInputWithClauseType[prop], index, [
              { clauseType: '', value: '' }
            ])
          }
        } else {
          for (const item in this.searchInputWithClauseType[prop]) {
            this.searchInputWithClauseType[prop][item] = ''
          }
        }
      }
      this.putSearchInputWithClauseTypeInQueryParams()
      this.updateUrl()
    },

    scrollToTop () {
      window.scrollTo(0, 0)
    }
  }
}
</script>
